import { axios } from "@/libraries/axios";
import {
	CreatePatientPayloadSchema,
	UpdatePatientPayloadSchema,
} from "@/schemas";
import type {
	PatchUpdatePatientResponse,
	PostCreatePatientResponse,
} from "@/types";
import omit from "lodash/omit";

class PatientService {
	async create(payload: CreatePatientPayloadSchema) {
		try {
			const parsedPayload = CreatePatientPayloadSchema.safeParse(payload);
			if (!parsedPayload.success) throw new Error(parsedPayload.error.message);
			const res = await axios.post<PostCreatePatientResponse>(
				"/api/v1/patients",
				{
					patient: omit(parsedPayload.data, ["caseId"]),
				},
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async update(payload: UpdatePatientPayloadSchema) {
		try {
			const parsedPayload = UpdatePatientPayloadSchema.safeParse(payload);
			if (!parsedPayload.success) throw new Error(parsedPayload.error.message);
			const { id, ...patient } = parsedPayload.data;
			const res = await axios.patch<PatchUpdatePatientResponse>(
				`/api/v1/patients/${id}`,
				{
					patient: omit(patient, ["caseId"]),
				},
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const patientService = Object.freeze(new PatientService());
